<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'labels', 'backgrounds'],
  methods: { 
    montarGrafico () {
       // Verifica se o gráfico já existe e o destrói antes de recriar
       if (this._chart) {
        this._chart.destroy();
      }
      
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.backgrounds,
            data: this.data
          }
        ]
      }, 
      {
        responsive: true, 
        maintainAspectRatio: true, 
        legend: {
          display: true,
          position: "top",
          fullWidth: true,
          labels: {
            boxWidth: 10,
            fontSize: 14
          }
        },
      })
    },
    
  },
  watch: {
    'labels': function () {
      console.log(123487777)
      this.montarGrafico()
    }
  },
  mounted() {
  //  this.montarGrafico()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/charts/DoughnutProducao.vue